var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ax-wrapper',_vm._g(_vm._b({attrs:{"align":"center","justify":"center","value":_vm.value}},'ax-wrapper',_vm.attrs,false),_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }